import { __awaiter } from "tslib";
import { Logger, MESSAGES, CssDependency, ScriptDependency, Loader, Tools } from '../sgvizler';
/**
 * Define the type of patterns for the options
 *
 * @class sgvizler.CHART_PATTERN_OPTIONS
 * @memberof sgvizler
 */
export var CHART_PATTERN_OPTIONS;
(function (CHART_PATTERN_OPTIONS) {
    CHART_PATTERN_OPTIONS[CHART_PATTERN_OPTIONS["EMPTY"] = 0] = "EMPTY";
    CHART_PATTERN_OPTIONS[CHART_PATTERN_OPTIONS["UNKNOWN"] = 1] = "UNKNOWN";
    CHART_PATTERN_OPTIONS[CHART_PATTERN_OPTIONS["VARIABLE"] = 2] = "VARIABLE";
    CHART_PATTERN_OPTIONS[CHART_PATTERN_OPTIONS["STYLE"] = 3] = "STYLE";
    CHART_PATTERN_OPTIONS[CHART_PATTERN_OPTIONS["CLASS"] = 4] = "CLASS";
    CHART_PATTERN_OPTIONS[CHART_PATTERN_OPTIONS["WIKI"] = 5] = "WIKI";
    CHART_PATTERN_OPTIONS[CHART_PATTERN_OPTIONS["OBJECT"] = 6] = "OBJECT";
})(CHART_PATTERN_OPTIONS || (CHART_PATTERN_OPTIONS = {}));
/**
 * Abstract class for all the charts. Ensures that chart types
 * correctly inherit methods from this class.
 * @class sgvizler.Chart
 * @abstract
 * @export
 * @memberof sgvizler
 */
export class Chart {
    /**
     * Constructor of all chart types created by
     * sgvizler.charts inherit from.
     * @memberof sgvizler.Chart
     * @constructor sgvizler.Chart
     */
    constructor() {
        /**
         * Give the options of chart
         * @property options
         * @memberof sgvizler.Chart
         * @public
         * @type {{}}
         */
        this.options = {};
        this._tabDependences = [];
        this._patternOptions = CHART_PATTERN_OPTIONS.EMPTY;
        this._width = '';
        this._height = '';
        this._optionsRaw = '';
        this._class = '';
        this._style = '';
        this._width = '100%';
        this._isDone = false;
        let currentThis = this;
        Loader.on('loaded', () => {
            if (currentThis.container != null &&
                !currentThis._isDone &&
                currentThis.isLoadedAllDependencies() &&
                currentThis._resultSparql !== null &&
                currentThis._resultSparql !== undefined) {
                currentThis.doDraw();
            }
        });
    }
    loadDependenciesAndDraw(result) {
        return __awaiter(this, void 0, void 0, function* () {
            Logger.log(this.container, 'Chart loaded dependencies : ' + this.container.id);
            // let promisesArray: Array<any> = []
            this._resultSparql = result;
            if (this.isLoadedAllDependencies()) {
                yield this.doDraw();
            }
            else {
                yield this.loadDependencies();
            }
        });
    }
    loadDependencies() {
        return __awaiter(this, void 0, void 0, function* () {
            let promisesArray = [];
            for (let dep of this._tabDependences) {
                promisesArray.push(dep.load());
            }
            return Promise.all(promisesArray);
        });
    }
    /**
     * Todo
     * @memberof sgvizler.Chart
     * @returns {CHART_PATTERN_OPTIONS}
     */
    get patternOptions() {
        return this._patternOptions;
    }
    /**
     * Todo
     * @memberof sgvizler.Chart
     * @returns {string}
     */
    get classHtml() {
        return this._class;
    }
    /**
     * Todo
     * @memberof sgvizler.Chart
     * @param {string} value
     */
    set classHtml(value) {
        this._class = value;
    }
    /**
     * Todo
     * @memberof sgvizler.Chart
     * @returns {string}
     */
    get style() {
        return this._style;
    }
    /**
     * Todo
     * @memberof sgvizler.Chart
     * @param {string} value
     */
    set style(value) {
        this._style = value;
    }
    /**
     *
     * @memberof sgvizler.Chart
     * @returns {Container}
     */
    get container() {
        return this._container;
    }
    /**
     * Todo
     * @memberof sgvizler.Chart
     * @param {Container} value
     */
    set container(value) {
        this._container = value;
    }
    /**
     * Todo
     * @memberof sgvizler.Chart
     * @returns {string}
     */
    get optionsRaw() {
        return this._optionsRaw;
    }
    /**
     * Todo
     * @memberof sgvizler.Chart
     * @param {string} value
     */
    set optionsRaw(value) {
        this._optionsRaw = value;
        this.doParseOptionsRaw();
    }
    /**
     * To read new options for interactive chart
     */
    get newOptionsRaw() {
        return this.optionsRaw;
    }
    /**
     * Todo
     * @memberof sgvizler.Chart
     * @returns {string}
     */
    get height() {
        return this._height;
    }
    /**
     * Todo
     * @memberof sgvizler.Chart
     * @param {string} value
     */
    set height(value) {
        this._height = value;
    }
    /**
     * Todo
     * @memberof sgvizler.Chart
     * @returns {string}
     */
    get width() {
        return this._width;
    }
    /**
     * Todo
     * @memberof sgvizler.Chart
     * @param {string} value
     */
    set width(value) {
        this._width = value;
    }
    /**
     * Todo
     * @memberof sgvizler.Chart
     * @returns {string}
     */
    getHTMLStyleOrClass() {
        let html = '';
        let opts = this.options;
        if (this._patternOptions === CHART_PATTERN_OPTIONS.CLASS) {
            html = Object.keys(opts).map((property) => '${opts[property]}').join(' ');
            html = 'class="' + html + '"';
        }
        if (this._patternOptions === CHART_PATTERN_OPTIONS.STYLE) {
            html = Object.keys(opts).map((property) => '${property}:${opts[property]}').join(';');
            html = 'style="' + html + '"';
        }
        return html;
    }
    addScript(url, loadBefore) {
        let dep = new ScriptDependency(url, loadBefore);
        this._tabDependences.push(dep);
        return dep;
    }
    addCss(url, loadBefore) {
        let dep = new CssDependency(url, loadBefore);
        this._tabDependences.push(dep);
        return dep;
    }
    isLoadedAllDependencies() {
        for (let dep of this._tabDependences) {
            if (!Loader.isLoaded(dep)) {
                return false;
            }
        }
        return true;
    }
    doDraw() {
        Logger.log(this.container, 'Chart started : ' + this._container.id);
        let currentThis = this;
        let isEmpty = false;
        if (currentThis._resultSparql === null
            || currentThis._resultSparql === undefined) {
            isEmpty = true;
        }
        else {
            let cols = currentThis._resultSparql.head.vars;
            let rows = currentThis._resultSparql.results.bindings;
            let noCols = cols.length;
            let noRows = rows.length;
            if (noCols === 0) {
                isEmpty = true;
            }
        }
        if (isEmpty) {
            Logger.displayFeedback(currentThis._container, MESSAGES.ERROR_DATA_EMPTY);
            Logger.log(currentThis.container, 'Chart finished with error : ' + currentThis._container.id);
        }
        else {
            currentThis.draw(currentThis._resultSparql).then(function (valeur) {
                currentThis._isDone = true;
                Logger.log(currentThis.container, 'Chart finished : ' + currentThis._container.id);
                Logger.fireDoneEvent(currentThis._container);
            }, function (error) {
                console.log(error);
                Logger.displayFeedback(currentThis._container, MESSAGES.ERROR_CHART, [error]);
                Logger.log(currentThis.container, 'Chart finished with error : ' + currentThis._container.id);
            });
        }
    }
    // noinspection JSValidateJSDoc
    // noinspection tslint
    /**
     * todo
     * @memberof sgvizler.Chart
     * @param {RegExp} patternOption
     * @param {CHART_PATTERN_OPTIONS} typePattern
     */
    execPattern(patternOption, typePattern) {
        let matchArray;
        let raw = this._optionsRaw;
        while ((matchArray = patternOption.exec(raw)) !== null) { // tslint:disable-line
            // this.options[matchArray[1].toLowerCase()] = matchArray[2].trim()
            // this.options[matchArray[1]] = matchArray[2].trim()
            Tools.assignProperty(this.options, matchArray[1], matchArray[2].trim());
            this._patternOptions = typePattern;
        }
    }
    /**
     * todo
     * @memberof sgvizler.Chart
     */
    doParseOptionsRaw() {
        // 3 possibilities
        // pattern option : separate by optionA=a|optionB=b
        // pattern style : any options, only style separate by ;
        // pattern class : words separate by space
        // noinspection TsLint
        let patternOption = /\|? *([^=]*) *= *([^=|]*)/iy; // tslint:disable-line
        let patternStyle = /([^:]+):([^:;]+) *;?/iy; // tslint:disable-line
        let patternClass = /([^ |;]+) ?/iy; // tslint:disable-line
        let patternWiki = /\!? *([^=]*) *= *([^=!]*)/iy; // tslint:disable-line
        let patternObject = /([^:{]+):([^:,}]+) *,?/iy; // tslint:disable-line // for PivotTable
        let raw = this._optionsRaw;
        if (raw === '') {
            this._patternOptions = CHART_PATTERN_OPTIONS.EMPTY;
        }
        else {
            this._patternOptions = CHART_PATTERN_OPTIONS.UNKNOWN;
        }
        if (this._optionsRaw.indexOf('{') === 0 && this.patternOptions === CHART_PATTERN_OPTIONS.UNKNOWN) {
            //this.execPattern(patternObject,CHART_PATTERN_OPTIONS.OBJECT) // todo ?
            this._patternOptions = CHART_PATTERN_OPTIONS.OBJECT;
        }
        if (this._optionsRaw.indexOf('|') === -1 && this.patternOptions === CHART_PATTERN_OPTIONS.UNKNOWN) {
            this.execPattern(patternWiki, CHART_PATTERN_OPTIONS.WIKI);
        }
        if (this.patternOptions === CHART_PATTERN_OPTIONS.UNKNOWN) {
            this.execPattern(patternOption, CHART_PATTERN_OPTIONS.VARIABLE);
        }
        if (this.patternOptions === CHART_PATTERN_OPTIONS.UNKNOWN) {
            this.execPattern(patternStyle, CHART_PATTERN_OPTIONS.STYLE);
        }
        if (this.patternOptions === CHART_PATTERN_OPTIONS.UNKNOWN) {
            let matchArray;
            let raw = this._optionsRaw;
            let i = 0;
            while ((matchArray = patternClass.exec(raw)) !== null) { // tslint:disable-line
                this.options['class' + i] = matchArray[2];
                this._patternOptions = CHART_PATTERN_OPTIONS.UNKNOWN;
                i++;
            }
        }
        if (this.patternOptions === CHART_PATTERN_OPTIONS.UNKNOWN) {
            Logger.displayFeedback(this.container, MESSAGES.ERROR_CHART_PATTERN_OPTION_UNKNOWN, [this._optionsRaw]);
        }
        else if (this.patternOptions === CHART_PATTERN_OPTIONS.WIKI ||
            this.patternOptions === CHART_PATTERN_OPTIONS.VARIABLE ||
            this.patternOptions === CHART_PATTERN_OPTIONS.STYLE) {
            if (this.options['width'] !== undefined) {
                this.width = this.options['width'];
            }
            if (this.options['height'] !== undefined) {
                this.height = this.options['height'];
            }
        }
    }
}
//# sourceMappingURL=data:application/json;base64,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